import * as React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/FormLabel": FormLabel, "@mui/material/FormControl": FormControl, "@mui/material/FormGroup": FormGroup, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormHelperText": FormHelperText, "@mui/material/Checkbox": Checkbox } } });
export default ClientProvider;
